<template>
    <div>
        <vue-progress-bar></vue-progress-bar>
        <vAlert v-model="showAlert" :type="alertData.type" dismissable :duration="3000" placement="top" width="90%">{{ alertData.text }}</vAlert>
        <router-view></router-view>
    </div>
</template>

<script>
import { alert as VAlert } from 'vue-strap'

export default {
    components: {
        VAlert
    },
    computed: {
        alertData: function()  {
            return this.$store.state.alertData;
        },
        showAlert: {
            get() {
                return this.$store.state.showAlert;
            },
            set(value) {
                this.$store.commit('SHOW_ALERT_UPDATED', value);
            }
        } 
    },
    methods: {
    },
    data: function()  {
        return {
        };
    },
    beforeCreate()  {
        this.$router.beforeEach((to, from, next) => {
            this.$Progress.start();
            next();               
        });

        this.$router.afterEach((to, from) => {
            this.$Progress.finish();
        })
    }
}

</script>

<style>
</style>
